var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.synths),function(synth){return _c('li',{key:synth.name,on:{"click":function($event){_vm.onSelect(synth)}}},[_c('img',{attrs:{"src":synth.image}}),_c('h3',[_vm._v(_vm._s(synth.name))])])}))}
var staticRenderFns = []

export { render, staticRenderFns }